export const IconLeftArrow = `<svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7995_488)">
<path d="M7.09863 0.788648L0.788774 6.80273L7.09863 13.2112" stroke="#3A3D4B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.47884 6.90137L22.0845 6.90137" stroke="#3A3D4B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_7995_488">
<rect width="22.8732" height="14" fill="white" transform="translate(22.8733 14) rotate(180)"/>
</clipPath>
</defs>
</svg>
`